import React, { useState, useEffect } from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { useAPI } from '../../ApiCalls/useAPI';
import { Card, Table } from 'tabler-react';
import './Performance.scss';

class PerformanceRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }

    checkResponse(data) {
        this.setState({
            data: data
        });
        // console.log(data, 'performance');
    }

    componentDidMount() {
        const { getPerformance } = useAPI();
        getPerformance()
            .then((response) => this.checkResponse(response))
            .catch((error) => console.error(error));
    }

    render() {
        return (
            <div className="container">
                <div
                    className="m-2 mt-4"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Performance</div>
                </div>
                <Tabs data={this.state.data}></Tabs>
            </div>
        );
    }
}

const Tabs = ({ data }) => {
    const [activeTab, setActiveTab] = useState('tab1');
    const handleTab1 = () => {
        setActiveTab('tab1');
    };
    const handleTab2 = () => {
        setActiveTab('tab2');
    };
    const handleTab3 = () => {
        setActiveTab('tab3');
    };
    const handleTab4 = () => {
        setActiveTab('tab4');
    };
    const tabsfunc = () => {
        switch (activeTab) {
            case 'tab1':
                return <FirstTab data={data} />;
            case 'tab2':
                return <SecondTab data={data.performance.dayobjects} />;
            case 'tab3':
                return <ThirdTab data={data.overallperformance} />;
            case 'tab4':
                return <FourthTab data={data.unittests.unittest} />;
            default:
                return <FirstTab data={data} />;
        }
    };
      return (
        <div>
          <div className="TabsPerformance">
                <ul className="navtabPerformance">
                    <li
                        style={{ justifyContent: 'center' }}
                        className={activeTab === 'tab1' ? 'active' : ''}
                        onClick={handleTab1}
                    >
                        <i className="fe fe-clock"></i>
                        <div>Today</div>
                    </li>
                    <li
                        className={activeTab === 'tab2' ? 'active' : ''}
                        onClick={handleTab2}
                    >
                        <i className="fe fe-calendar"></i>
                        <div>Last 2 Weeks</div>
                    </li>
                    <li
                        style={{ justifyContent: 'center' }}
                        className={activeTab === 'tab3' ? 'active' : ''}
                        onClick={handleTab3}
                    >
                        <i className="fe fe-activity"></i>
                        <div>Overall</div>
                    </li>
                    <li
                        style={{ justifyContent: 'center' }}
                        className={activeTab === 'tab4' ? 'active' : ''}
                        onClick={handleTab4}
                    >
                        <i className="fe fe-pie-chart"></i>
                        <div>Unit Test</div>
                    </li>
                </ul>
                <div className="outlet">{tabsfunc()}</div>
            </div>
        </div>
    );
};

const FirstTab = ({ data }) => {
    return data.performance === undefined ? (
        <h6>loading...</h6>
    ) : (
        <div className="FirstTab">
            {data.performance.dayobjects[0].holiday === 'true' ? (
                <Card
                    title={
                        <div>{data.performance.dayobjects[0].date} (Today)</div>
                    }
                    body={
                        <div className="daycard">
                            <Table>
                                <Table.Header>
                                    <Table.ColHeader>Subject</Table.ColHeader>
                                    <Table.ColHeader>Lab</Table.ColHeader>
                                    <Table.ColHeader>Marks(%)</Table.ColHeader>
                                    <Table.ColHeader>Quiz</Table.ColHeader>
                                    <Table.ColHeader>Marks(%)</Table.ColHeader>
                                </Table.Header>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Col>NA</Table.Col>
                                        <Table.Col>NA</Table.Col>
                                        <Table.Col>NA</Table.Col>
                                        <Table.Col>NA</Table.Col>
                                        <Table.Col>NA</Table.Col>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </div>
                    }
                />
            ) : (
                <Card
                    title={
                        <div>{data.performance.dayobjects[0].date} (Today)</div>
                    }
                    body={
                        <di className="daycard" v>
                            <Table>
                                <Table.Header>
                                    <Table.ColHeader>Subject</Table.ColHeader>
                                    <Table.ColHeader>Lab</Table.ColHeader>
                                    <Table.ColHeader>Marks(%)</Table.ColHeader>
                                    <Table.ColHeader>Quiz</Table.ColHeader>
                                    <Table.ColHeader>Marks(%)</Table.ColHeader>
                                </Table.Header>
                                <Table.Body>
                                    {data.performance.dayobjects[0].subjects.map(
                                        (subject) => {
                                            if (subject.subject === '--') {
                                                return (
                                                    <Table.Row className="no_data">
                                                        <Table.Col colSpan={5}>
                                                            No data available
                                                        </Table.Col>
                                                    </Table.Row>
                                                );
                                            }
                                            return (
                                                <Table.Row>
                                                    <Table.Col>
                                                        {subject.subject}
                                                    </Table.Col>
                                                    <Table.Col>
                                                        {subject.labsattended}{' '}
                                                        of {subject.totallabs}
                                                    </Table.Col>
                                                    <Table.Col>
                                                        {subject.labpercentage}
                                                    </Table.Col>
                                                    <Table.Col>
                                                        {subject.quizattended}{' '}
                                                        of {subject.totalquiz}
                                                    </Table.Col>
                                                    <Table.Col>
                                                        {subject.quizpercentage}
                                                    </Table.Col>
                                                </Table.Row>
                                            );
                                        }
                                    )}
                                </Table.Body>
                            </Table>
                        </di>
                    }
                />
            )}
        </div>
    );
};

const SecondTab = ({ data }) => {
    // console.log(data, 'last2weeks');
    return (
        <div className="SecondTab">
            {data.map((day) => (
                <Daycard data={day} />
            ))}
        </div>
    );
};

const ThirdTab = ({ data }) => {
    // console.log(data, 'overall');
    return (
        <div className="ThirdTab">
            <Overallpractical data={data.overall}></Overallpractical>
            <Overalltotal data={data.total}></Overalltotal>
        </div>
    );
};

const FourthTab = ({ data }) => {
    // console.log(data, 'unit tests');
    if (data.length === 0) {
        return (
            <div className="">
                <h6>NO DATA FOUND</h6>
            </div>
        );
    }
    return (
        <div className="FourthTab">
            {data.map((item) => {
                return (
                    <Card
                        isCollapsible
                        title={item.unittest}
                        body={
                            <div>
                                <Unittestcontent data={item.theory} />
                            </div>
                        }
                    />
                );
            })}
            <div className="mt-2 mb-2">{data.updatedon}</div>
        </div>
    );
};

const Unittestcontent = ({ data }) => {
    if (data === null) {
        return <div className="">No Data Found</div>;
    }
    return (
        <div>
            <Table>
                <Table.Header>
                    <Table.ColHeader>Subject</Table.ColHeader>
                    <Table.ColHeader>Score</Table.ColHeader>
                </Table.Header>
                <Table.Body>
                    {data.map((mar) => (
                        <Table.Row>
                            <Table.Col>{mar.subject}</Table.Col>
                            <Table.Col>
                                {mar.scored} of {mar.total}
                            </Table.Col>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
      );
};

const Overallpractical = ({ data }) => {
    if (data === null) {
        return (
            <div className="">
                <Card title="Practicals" body="NO DATA FOUND" />
            </div>
        );
    }
    return (
        <Card
            title="Practicals"
            body={
                <div>
                    <Table>
                        <Table.Header>
                            <Table.ColHeader>Subject</Table.ColHeader>
                            <Table.ColHeader>Lab</Table.ColHeader>
                            <Table.ColHeader>Marks(%)</Table.ColHeader>
                            <Table.ColHeader>Quiz</Table.ColHeader>
                            <Table.ColHeader>Marks(%)</Table.ColHeader>
                        </Table.Header>
                        <Table.Body>
                            {data.subjects.map((subject) => (
                                <Table.Row>
                                    <Table.Col>{subject.subjectname}</Table.Col>
                                    <Table.Col>
                                        {subject.labsattended}
                                    </Table.Col>
                                    <Table.Col>
                                        {subject.labpercentage}
                                    </Table.Col>
                                    <Table.Col>
                                        {subject.quizattended}
                                    </Table.Col>
                                    <Table.Col>
                                        {subject.quizpercentage}
                                    </Table.Col>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            }
        />
    );
};

const Overalltotal = ({ data }) => {
    return (
        <Card
            title="Total"
            body={
                <Table>
                    <Table.Body>
                        <Table.Row>
                            <Table.Col>
                                {data.labsattended} of {data.totallabs}
                            </Table.Col>
                            <Table.Col>{data.labpercentage}</Table.Col>
                            <Table.Col>
                                {data.quizattended} of {data.totalquiz}
                            </Table.Col>
                            <Table.Col>{data.quizpercentage}</Table.Col>
                        </Table.Row>
                    </Table.Body>
                </Table>
            }
        />
    );
};

const Daycard = ({ data }) => {
    if (data.length === 0) {
        return <div></div>;
    } else {
        if (data.holiday === 'true') {
            return (
                <Card
                    isCollapsed
                    isCollapsible
                    title={data.date}
                    body={
                        <div className="daycard">
                            <Table>
                                <Table.Header>
                                    <Table.ColHeader>Subject</Table.ColHeader>
                                    <Table.ColHeader>Lab</Table.ColHeader>
                                    <Table.ColHeader>Marks(%)</Table.ColHeader>
                                    <Table.ColHeader>Quiz</Table.ColHeader>
                                    <Table.ColHeader>Marks(%)</Table.ColHeader>
                                </Table.Header>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Col>NA</Table.Col>
                                        <Table.Col>NA</Table.Col>
                                        <Table.Col>NA</Table.Col>
                                        <Table.Col>NA</Table.Col>
                                        <Table.Col>NA</Table.Col>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </div>
                    }
                />
            );
        }
        return (
            <Card
                isCollapsed
                isCollapsible
                title={data.date}
                body={
                    <div className="daycard">
                        <Table>
                            <Table.Header>
                                <Table.ColHeader>Subject</Table.ColHeader>
                                <Table.ColHeader>Lab</Table.ColHeader>
                                <Table.ColHeader>Marks(%)</Table.ColHeader>
                                <Table.ColHeader>Quiz</Table.ColHeader>
                                <Table.ColHeader>Marks(%)</Table.ColHeader>
                            </Table.Header>
                            <Table.Body>
                                {data.subjects.map((subject) => {
                                    if (subject.subject === '--') {
                                        return (
                                            <Table.Row className="no_data">
                                                <Table.Col colSpan={5}>
                                                    No data available
                                                </Table.Col>
                                            </Table.Row>
                                        );
                                    }
                                    return (
                                        <Table.Row>
                                            <Table.Col>
                                                {subject.subject}
                                            </Table.Col>
                                            <Table.Col>
                                                {subject.labsattended} of{' '}
                                                {subject.totallabs}
                                            </Table.Col>
                                            <Table.Col>
                                                {subject.labpercentage}
                                            </Table.Col>
                                            <Table.Col>
                                                {subject.quizattended} of{' '}
                                                {subject.totalquiz}
                                            </Table.Col>
                                            <Table.Col>
                                                {subject.quizpercentage}
                                            </Table.Col>
                                        </Table.Row>
                                    );
                                })}
                            </Table.Body>
                        </Table>
                    </div>
                }
            />
        );
    }
};

export default PerformanceRequest;
